/* src/app/features/modalidade_garantia/modal-encerrar-taxa-atualizacao-garantia/modal-encerrar-taxa-atualizacao-garantia.component.scss */
.alert {
  margin-top: 1em !important;
}
/*# sourceMappingURL=modal-encerrar-taxa-atualizacao-garantia.component.css.map */
